var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.923,
    height: 46.269,
    viewBox: "0 0 39.923 46.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_18948",
    x: 4.283,
    y: 0,
    width: 24.512,
    height: 28.182,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18953",
    x: 1.625,
    y: 11.586,
    width: 36.039,
    height: 34.683,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18954",
    x: 9.054,
    y: 0,
    width: 21.18,
    height: 28.182,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18955",
    x: 13.506,
    y: 0,
    width: 21.498,
    height: 27.024,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18956",
    x: 9.69,
    y: 10.177,
    width: 19.908,
    height: 19.908,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7152",
    "data-name": "Group 7152",
    transform: "translate(-104.295 -183.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7151",
    "data-name": "Group 7151",
    transform: "translate(104.295 186.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_70",
    "data-name": "Polygon 70",
    transform: "translate(0 0)",
    fill: "#fbbb4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#ffe87a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7150",
    "data-name": "Group 7150",
    transform: "translate(115.988 189.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.69, -6)",
    filter: "url(#Path_18948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18948-2",
    "data-name": "Path 18948",
    d: "M26.919,959.362v7.633l3.5,1.4v-9.034Zm6.341,10.177Zm0,0c-.517.011.547,0,.02,0h-.02Z",
    transform: "translate(-13.64 -953.36)",
    fill: "#17256b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.69, -6)",
    filter: "url(#Path_18953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18953-2",
    "data-name": "Path 18953",
    d: "M32.951,973.944Zm0,0L30.5,978.973l-5.5.805,3.976,3.906-.934,5.526,4.91-2.605,4.91,2.6-.934-5.524,3.976-3.906-5.5-.808-2.455-5.028Z",
    transform: "translate(-13.31 -955.86)",
    fill: "#f3f7ff",
    stroke: "#fbbb4a",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.69, -6)",
    filter: "url(#Path_18954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18954-2",
    "data-name": "Path 18954",
    d: "M32.675,959.362v9.551l1.57.626,1.61-.646v-9.531Zm1.57,10.177c-.517.011.547,0,.02,0h-.02Z",
    transform: "translate(-14.62 -953.36)",
    fill: "#ca373c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.69, -6)",
    filter: "url(#Path_18955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18955-2",
    "data-name": "Path 18955",
    d: "M38.046,959.362v9.024l3.5-1.391v-7.633Z",
    transform: "translate(-15.54 -953.36)",
    fill: "#17256b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.69, -6)",
    filter: "url(#Path_18956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18956-2",
    "data-name": "Path 18956",
    d: "M34.376,971.641Zm0,0a.964.964,0,1,0,.02,0h-.02Zm.02,1.908h0Z",
    transform: "translate(-14.75 -955.46)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovoice);
export default __webpack_public_path__ + "static/media/novoice.d16e4df0adf7110d53ed46ad55760793.svg";
export { ForwardRef as ReactComponent };